import React from 'react';
import { isSmartObject } from '../../objects/guards';
import { type SidePanelItem } from '../../shared-types';
import useSelectedObject from '../hooks/useSelectedObject';
import SmartObjectEditor from './SmartObjectEditor';

const SmartObjectTabContent: React.FC = () => {
  const smartObject = useSelectedObject({
    predicate: isSmartObject,
  });

  if (!smartObject) {
    return null;
  }

  return (
    <aha-sidepanel-item>
      <i className='fa-regular fa-pen-to-square' />
    </aha-sidepanel-item>
  );
};

export const smartObjectSidePanelItem: SidePanelItem = {
  id: 'smartObject',
  name: 'Smart shape',
  icon: 'fa-regular fa-pen-to-square',
  alwaysRendered: false,
  tabContent: <SmartObjectTabContent />,
  content: <SmartObjectEditor />,
};
